import { Contexts } from 'constants/context';

const contextsThatHideHeader = [Contexts.Login, Contexts.Authentication];
const contextsThatHideSidebar = [Contexts.Login, Contexts.Authentication];

const hideElements = {
  contextsThatHideHeader,
  contextsThatHideSidebar,
};

export default hideElements;
